import { render, staticRenderFns } from "./PeriodicityName.vue?vue&type=template&id=6c8fe1e6&scoped=true"
import script from "./PeriodicityName.vue?vue&type=script&lang=js"
export * from "./PeriodicityName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8fe1e6",
  null
  
)

export default component.exports